import axios from 'axios';

import { publicAxiosHeaderV2, getV2RootUrl } from 'common/helpers/apiHelper';

export const getResourceBundle = () =>
  axios.get(`${getV2RootUrl()}/resource-bundle/for-web`, publicAxiosHeaderV2());
